"use no memo";

/* eslint-disable no-restricted-syntax, @typescript-eslint/no-use-before-define */
import { isLocalStorageAllowed } from '@local/utils';
import { isRecord } from 'helpers/types';
import { COMPLETED_ORDER_STATUSES } from 'helpers/order';

import { LocalOrderType } from '.';

export const REDUX_LEGACY_ORDER_SESSION_KEY = 'directPersist:order';

function isValidOrder(maybeOrder: unknown): maybeOrder is LocalOrderType {
  return isRecord(maybeOrder) && 'fulfill_method' in maybeOrder;
}

export function loadOrderDataFromStorage(
  orderId: string
): LocalOrderType | undefined {
  migrateLegacyOrderData();

  let order: unknown;

  if (isLocalStorageAllowed()) {
    try {
      order = JSON.parse(localStorage.getItem(orderId) || '{}');
    } catch (_e) {
      localStorage.removeItem(orderId);
    }
  }

  if (!isValidOrder(order)) {
    return undefined;
  }

  // Don't load completed orders from storage to prevent automatic redirect to confirmation page
  // when user navigates back to checkout after placing an order
  if (order.status && COMPLETED_ORDER_STATUSES.includes(order.status)) {
    localStorage.removeItem(orderId);
    return undefined;
  }

  return {
    ...order,
    // immediately revalidate the order on load
    pending_validation: true,
  };
}

export function writeOrderDataToStorage(
  orderId: string,
  orderData: Record<string, unknown> | undefined
) {
  if (isLocalStorageAllowed()) {
    if (!orderData) {
      localStorage.removeItem(orderId);
      return;
    }

    localStorage.setItem(orderId, JSON.stringify(orderData));
  }
}

function isLegacyOrderData(input: unknown): input is { orderData: string } {
  return (
    isRecord(input) && 'orderData' in input && input.orderData === 'string'
  );
}

export function migrateLegacyOrderData() {
  if (isLocalStorageAllowed()) {
    const rawData = localStorage.getItem(REDUX_LEGACY_ORDER_SESSION_KEY);

    if (!rawData) {
      return;
    }

    const data = JSON.parse(rawData);

    if (!isLegacyOrderData(data)) {
      return;
    }

    const parsedOrderData = JSON.parse(data.orderData);

    if (!isRecord(parsedOrderData)) {
      return;
    }

    for (const [orderId, mOrderData] of Object.entries(parsedOrderData)) {
      localStorage.setItem(orderId, JSON.stringify(mOrderData));
    }

    localStorage.removeItem(REDUX_LEGACY_ORDER_SESSION_KEY);
  }
}
